import { useId, useState, type ReactNode } from 'react';

/**
 * The ⓘ beside a plan setting. Hover, focus or tap it to read what the
 * setting means in plain words; Escape or moving away closes it.
 */
export function InfoTip({ label, children }: { label: string; children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const id = useId();
  return (
    <span className="relative inline-flex align-middle" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      <button
        type="button"
        aria-label={`About ${label}`}
        aria-describedby={open ? id : undefined}
        aria-expanded={open}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        onClick={() => setOpen((o) => !o)}
        onKeyDown={(e) => { if (e.key === 'Escape') setOpen(false); }}
        className="w-6 h-6 rounded-full border border-slate-500 text-slate-300 text-[13px] font-semibold italic font-serif leading-none hover:border-cyan-400 hover:text-cyan-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-500"
      >
        i
      </button>
      {open && (
        <span
          role="tooltip"
          id={id}
          className="absolute left-0 top-full mt-2 z-50 w-[22rem] max-w-[calc(100vw-2rem)] rounded-lg border border-slate-600 bg-slate-900 p-4 text-left text-[15px] font-normal normal-case tracking-normal leading-relaxed text-slate-200 shadow-2xl"
        >
          <span className="block font-semibold text-white mb-1">{label}</span>
          {children}
        </span>
      )}
    </span>
  );
}
